import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class IshodiucenjaPopisService {

  constructor(private _http: Http) { }

  dohvatiSve(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_kompetencije', a)
    .map(res => res.json());
  }

  dohvatiAktivnaPodrucjaznanja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_aktivna_podrucjaznanja', a)
    .map(res => res.json());
  }

  dohvatiVrsteuvjerenja(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_vrsteuvjerenja', a)
    .map(res => res.json());
  }

  spremiKompetenciju(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kompetencija_spremi', a)    
    .map(res => res.json()); 
  }

  urediKompetenciju(a: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'kompetencija_uredi', a)    
    .map(res => res.json()); 
  }

  obrisiKompetenciju(a: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'kompetencija_obrisi', a)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/ishodiucenja-popis/ishodiucenja-popis.service.ts